var map = {
	"./Line 3.png": 146,
	"./Line 3@2x.png": 730,
	"./Polygon 1.png": 234,
	"./Polygon 1@2x.png": 990,
	"./Polygon 2.png": 903,
	"./Polygon 2@2x.png": 638,
	"./Rectangle 2.png": 603,
	"./Rectangle 2@2x.png": 340,
	"./benQMonitor.jpg": 468,
	"./camera-clamp.png": 388,
	"./darkModeToggleOff.svg": 584,
	"./darkModeToggleOn.svg": 107,
	"./desk.png": 137,
	"./gaming_setup.png": 665,
	"./grovemade.png": 878,
	"./minusW.svg": 455,
	"./personal_desktop.png": 480,
	"./plus.png": 477,
	"./plusW.svg": 750,
	"./triangleLeft.svg": 696,
	"./triangleRight.svg": 37,
	"./user-img.png": 945,
	"./user-img@2x.png": 609,
	"./vs-code.png": 311,
	"./vs-code@2x.png": 69,
	"./vscode.png": 445,
	"./wallpapers.jpg": 113,
	"./work_desktop.png": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 837;